import MetadataDefinitions from '@/shared/types/metadata/metadataDefinitions.type';

type Args = {
  metadataDefinitions: MetadataDefinitions[];
  requiredLevel: 'OPTIONAL' | 'REQUIRED';
  levelConstraint: 'ATOM' | 'INVENTORY';
};

const filterInventoryMetadata = ({
  metadataDefinitions,
  requiredLevel,
  levelConstraint,
}: Args) => {
  return metadataDefinitions.filter(
    (definition) =>
      definition.required_level === requiredLevel &&
      definition.level_constraint === levelConstraint,
  );
};

export default filterInventoryMetadata;
